import ServiceCard from "@/components/ServiceCard";
import { SERVICES } from "@/lib/constants";
import { useSEO } from "@/lib/useSEO";

export default function ServicesIndex() {
  useSEO({
    title: "Academic Services — Thesis, Synopsis, Research Paper, Formatting, Printing · ScholarPrintHub",
    description: "Complete list of academic services offered by ScholarPrintHub — thesis writing assistance, synopsis, research paper, formatting, plagiarism check, hard binding, and doorstep delivery.",
    keywords: "thesis writing assistance, synopsis writing service, research paper support, formatting service, plagiarism check, thesis printing binding, academic services india",
  });
  return (
    <div data-testid="services-page" className="container-app py-20">
      <span className="section-eyebrow">Services</span>
      <div className="divider-gold mt-2 mb-4" />
      <h1 className="font-display text-4xl sm:text-5xl text-navy max-w-3xl">Every academic service and printing option under one roof.</h1>
      <p className="mt-4 text-slate-600 max-w-2xl">Choose the service that matches your milestone — from synopsis to hard-bound thesis delivery.</p>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {SERVICES.map((s) => (<ServiceCard key={s.slug} service={s} />))}
      </div>
    </div>
  );
}
